/**
 * UI Interactions Module
 * Responsável por interações de interface do usuário
 */

/**
 * Inicializa interações de UI
 */
export function initUIInteractions() {
    // Verificar se o usuário está autenticado para funcionalidades específicas
    if (window.isAuthenticated) {
        initAuthenticatedInteractions();
    }
    
    // Funcionalidades sempre disponíveis
    initGlobalInteractions();
}

/**
 * Inicializa interações para usuários autenticados
 */
function initAuthenticatedInteractions() {
    initLogout();
    initUserCreationValidation();
    initPasswordChangeModal();
}

/**
 * Inicializa interações globais (sempre disponíveis)
 */
function initGlobalInteractions() {
    // Funcionalidades que não requerem autenticação
    initTooltips();
    initModals();
}

/**
 * Inicializa funcionalidade de logout
 */
function initLogout() {
    const logoutButtons = document.querySelectorAll('.logout-btn, [data-action="logout"]');
    
    logoutButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            if (confirm('Tem certeza que deseja sair do sistema?')) {
                // Mostrar loading
                this.innerHTML = '<i class="sg sg-spinner-gap animate-spin"></i> Saindo...';
                this.disabled = true;
                
                // Redirecionar para logout
                setTimeout(() => {
                    window.location.href = this.getAttribute('href') || '/logout';
                }, 1000);
            }
        });
    });
}

/**
 * Inicializa validação de criação de usuário
 */
function initUserCreationValidation() {
    const userCreationForm = document.querySelector('#userCreationForm');
    if (!userCreationForm) return;
    
    const passwordField = userCreationForm.querySelector('#password');
    const confirmPasswordField = userCreationForm.querySelector('#confirmPassword');
    
    if (passwordField && confirmPasswordField) {
        confirmPasswordField.addEventListener('blur', function() {
            validatePasswordMatch(passwordField, confirmPasswordField);
        });
        
        passwordField.addEventListener('input', function() {
            if (confirmPasswordField.value) {
                validatePasswordMatch(passwordField, confirmPasswordField);
            }
        });
    }
}

/**
 * Valida se as senhas coincidem
 */
function validatePasswordMatch(passwordField, confirmPasswordField) {
    const password = passwordField.value;
    const confirmPassword = confirmPasswordField.value;
    
    if (password !== confirmPassword) {
        confirmPasswordField.setCustomValidity('As senhas não coincidem');
        confirmPasswordField.classList.add('is-invalid');
    } else {
        confirmPasswordField.setCustomValidity('');
        confirmPasswordField.classList.remove('is-invalid');
    }
}

/**
 * Inicializa modal de alteração de senha
 */
function initPasswordChangeModal() {
    const passwordChangeModal = document.querySelector('#passwordChangeModal');
    if (!passwordChangeModal) return;
    
    const form = passwordChangeModal.querySelector('form');
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const submitButton = form.querySelector('button[type="submit"]');
            const originalText = submitButton.textContent;
            
            // Mostrar loading
            submitButton.innerHTML = '<i class="sg sg-spinner-gap animate-spin"></i> Alterando...';
            submitButton.disabled = true;
            
            // Simular processamento
            setTimeout(() => {
                this.submit();
            }, 1500);
        });
    }
}

/**
 * Inicializa tooltips
 */
function initTooltips() {
    // Inicializar tooltips do Bootstrap se disponível
    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }
}

/**
 * Inicializa modais
 */
function initModals() {
    // Funcionalidades básicas de modal que não requerem autenticação
    const modalTriggers = document.querySelectorAll('[data-bs-toggle="modal"]');
    
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
            const targetModal = document.querySelector(this.getAttribute('data-bs-target'));
            if (targetModal) {
                // Lógica adicional se necessário
            }
        });
    });
}

/**
 * Função para exibir modal de sucesso de senha
 * Mantida para compatibilidade
 */
export function modalPassSuccess() {
    const modal = document.querySelector('#passwordSuccessModal');
    if (modal && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        const modalInstance = new bootstrap.Modal(modal);
        modalInstance.show();
    }
}

/**
 * Previne saída de páginas de cadastro sem salvar
 */
export function initPageExitPrevention() {
    // DESABILITADO: Esta funcionalidade foi substituída pelo Form Guard
    // O Form Guard em utils/form-guard.js agora gerencia a proteção de formulários
    // de forma mais inteligente, ativando apenas em páginas /create e /edit
    // initPageExitPrevention: Desabilitado - usando Form Guard
}
